<template>
    <div class="payBidDetail">
        <div class="topNav">
            <el-button size="mini" @click="()=> { $router.back(-1) }">返回</el-button>
            <span v-has="'06020018'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="save"
                    :disabled="!(headInfo.costStatus === '1' || headInfo.costStatus === '4')">提交</el-button>
            </span>
        </div>
        <div class="payBidDetail-cont-box">
            <div class="content">
                <div style="width:100%;">
                    <div><span class="content-title">{{headInfo.bidName}}</span><span class="content-label">{{headInfo.costStatusText}}</span></div>
                    <div class="content-desc">
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                        <span class="content-desc-item">订单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                        <span class="content-desc-item">订单项<span class="content-desc-cont">{{headInfo.orderTypeText}}</span></span>
                        <span class="content-desc-item">缴纳方式<span class="content-desc-cont">{{headInfo.payTypeText}}</span></span>
                    </div>
                </div>
                <div class="content-right">
                    <div style="margin-right:30px;width: 108px;">
                        <div><span class="money">{{headInfo.receivePayAmount}} </span>元</div>
                        <div style="margin-top:4px;">应付金额</div>
                    </div>
                </div>
            </div>
            <div style="padding:10px;">
                <div class="upload_enclosure">
                    <div>凭证上传<span>（请上传银行转账信息凭证）</span></div>
                    <div class="upload_enclosure_top">
                        <span v-has="'06020017'">
                            <Upload :text="'上传'" :uploadDisplayType="'iconAndText'" @uploadSuccess="uploadSuccess"></Upload>
                        </span>
                    </div>
                </div>
                <el-table :data="moduleFileInfo" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column type="index" label="序号" align="center"></el-table-column>
                    <el-table-column prop="fileName" label="文件名称" width="700" align="center"></el-table-column>
                    <el-table-column prop="createTime" label="上传时间" width="500" align="center"></el-table-column>
                    <el-table-column prop="address" label="操作" align="center">
                        <template slot-scope="scope">
                            <span v-has="'06020019'">
                                <el-button class="margin-left" size="mini" type="text" @click="actionFn(scope.row, '0')">预览</el-button>
                            </span>
                            <span v-has="'06020020'">
                                <el-button class="margin-left" size="mini" type="text" @click="actionFn(scope.row, '1')">下载</el-button>
                            </span>
                            <span v-has="'06020021'">
                                <el-button class="margin-left" size="mini" type="text" @click="actionFn(scope.row, '2', scope.$index)"
                                    v-if="(headInfo.costStatus === '1' || headInfo.costStatus === '4')">删除</el-button>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
import { filePreview } from '@/utils/filePreview.js';
import Upload from '../../../components/upload/Index.vue';
import { bidBid4Cost, offlineRemittance } from '../../../../lsrm/api/myBidding.js';
import { delModuleFile } from '../../../../lsrm/api/annoMana.js';
import dayjs from 'dayjs';
export default {
    components: {
        Upload
    },
    data() {
        return {
            moduleFileInfo: [],
            uploadData: {},
            headInfo: '',
            dictData: []
        };
    },
    mounted() {
        let params = {};
        if (this.$route.query.myBidFlag) {
            params = { id: this.$route.query.id, payType: this.$route.query.payType };
        } else {
            params = { costId: this.$route.query.id, payType: this.$route.query.payType };
        }
        bidBid4Cost(params).then(res => {
            if (res && +res.code === 0) {
                dictWithUrl('BID_COST_STATUS,BID_PAY_TYPE,BID_EXPENSE_ORDER_TYPE').then(item => {
                    this.dictData = item.data;
                    this.headInfo = this.dataFormat(res.data);
                    this.moduleFileInfo = res.data.bidModuleFiles || [];
                });
            }
        });
    },
    methods: {
        dataFormat(list) {
            list.costStatusText = this.dictData.BID_COST_STATUS[list.costStatus];
            list.orderTypeText = this.dictData.BID_EXPENSE_ORDER_TYPE[list.orderType];
            list.payTypeText = this.dictData.BID_PAY_TYPE[list.payType];
            return list;
        },
        uploadSuccess(res) {
            this.uploadData = res.data.data;
            this.moduleFileInfo = [];
            this.moduleFileInfo.push({
                fileName: res.data.data.localFileName,
                createTime: dayjs(res.data.timestamp.split('.')[0]).format('YYYY-MM-DD HH:mm:ss'),
                fileUrl: res.data.data.downUrl,
                fileId: res.data.data.id
            });
        },
        delModuleFileFn(id, index) {
            delModuleFile(id).then((res) => {
                if (res && +res.code === 0) {
                    this.$message.success('删除成功！');
                    this.moduleFileInfo.splice(index, 1);
                }
            });
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else if (type === '2') {
                if (row.id) {
                    this.delModuleFileFn(row.id, index);
                } else {
                    this.$message.success('删除成功！');
                    this.moduleFileInfo.splice(index, 1);
                }
            } else {
                filePreview(row);
            }
        },
        save() {
            if (this.moduleFileInfo.length === 0) {
                this.$message.warning('请上传银行转账信息凭证附件！');
                return;
            }
            const par = {
                id: this.headInfo.costId,
                bidModuleFiles: this.moduleFileInfo,
                bidNo: this.headInfo.bidNo,
                supplierCode: this.headInfo.supplierCode,
                supplierName: this.headInfo.supplierName,
                orderNo: this.headInfo.orderNo,
                contactName: this.headInfo.contactName,
                contactNumber: this.headInfo.contactNumber,
                receivePayAmount: this.headInfo.receivePayAmount,
                actualReceivePay: this.headInfo.actualReceivePay
            };
            offlineRemittance(par).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('提交成功！');
                    this.$router.push({
                        name: 'myBidding'
                    });
                }
            });
        }
    }
};
</script>
<style lang="less">
.payBidDetail {
    margin: 0 10px;
    font-size: 12px;
    background: #fff;
    .margin-left{
        margin-left: 10px;
    }
    .payBidDetail-cont-box {
        overflow-y: auto;
        min-height: calc(~"100vh - 110px") !important;
        max-height: calc(~"100vh - 110px") !important;
    }
    .topNav {
        padding-left: 10px;
        width: 100%;
        height: 46px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
    .content {
        margin: 10px;
        padding: 14px;
        min-width: 1400px;
        box-sizing: border-box;
        background: #F8F8F8;
        vertical-align: middle;
        display: flex;
        align-items: center;
        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }
        .content-label {
            margin-left: 12px;
            padding: 3px 6px;
            border-radius: 2px;
            background: #FF7C24;
            display: inline-block;
            color: #fff;
        }
        .content-desc {
            margin-top: 15px;
            width: 70%;
            display: flex;
            flex-wrap: wrap;
        }
        .content-desc-item {
            margin: 0 20px 4px 0;
            color: #888888;
        }
        .content-desc-cont {
            margin-left: 5px;
            color: #333333;
        }
        .content-right {
            margin-right: 30px;
            display: flex;
        }
        .money {
            font-size: 18px;
            font-weight: 700;
            color: #FF8800;
        }
    }
    .el-tabs__item {
        font-size: 12px;
    }
    .payIframe {
        width: 100%;
        height: 100%;
        border: none;
    }
    .upload_enclosure {
        margin-bottom: 10px;
        width:100%;
        display: flex;
        justify-content: space-between;
    }
    .upload_enclosure_top {
        color:#00BCBF;
        cursor:pointer;
        display: flex;
        align-items: center;
    }
}
</style>
